export const mepRef14Options = ['forecast', 'smoke', 'warnings', 'rain', 'wind', '24-hours', 'other'] as const;
